import configJson from "./config.json";
export const API_VERSION = "v1";
export const API_VERSION_V2 = "v2";
export const API_VERSION_V3 = "v3";
export const API_VERSION_V4 = "v4";
export const { FORTIFIED_DATA_API_URL, APPLICATION_INSIGHTS_INSTRUMENTATION_KEY } = configJson;
